import { Button, Table, Space } from "antd";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { statuses } from "@/config";
import { Select } from "antd";
import dayjs from "dayjs";

const CompassionateRequests = () => {
  const [compassionateRequests, setCompassionateRequests] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);

  const loadData = async () => {
    try {
      const { data } = await axios.get(
        `compassionate_access_requests?status=medmonk_submitted,prescriber_submitted`,
      );
      setCompassionateRequests(data);
    } catch (e) {
      api.error({
        message: "Load data failed",
        description: "Something is wrong.",
        duration: 0,
      });
      console.error(e);
    } finally {
      setTableLoading(false);
    }
  };

  let renderRef = useRef(false);

  useEffect(() => {
    if (renderRef.current) {
      renderRef.current = false;
      return;
    }
    loadData();
  }, [status]);

  const columns = [
    {
      title: "Date Requested",
      dataIndex: "created_at",
      key: "created_at",
      align: "center",
      render: (text) => text ? dayjs(text).format("MM-DD-YYYY") : "-",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      align: "center",
      render: (tag, record) => {
        const status = statuses.find(
          (status) => status.value === record.status,
        );
        return (
          <>
            <span className={`${status.color} rounded-md px-2 py-1 text-white`}>
              {status.label}
            </span>
          </>
        );
      },
    },
    {
      title: "Patient Name",
      dataIndex: "patient_first_name",
      key: "patient_first_name",
      align: "center",
      render: (tag, record) => (
        <>
          {record.patient_first_name} {record.patient_last_name}
        </>
      ),
    },
    {
      title: "Date of Birth",
      dataIndex: "patient_date_of_birth",
      key: "patient_date_of_birth",
      align: "center",
      render: (text) => text ? dayjs(text).format("MM-DD-YYYY") : "-",
    },
    {
      title: "Gender",
      dataIndex: "patient_gender",
      key: "patient_gender",
      align: "center",
    },
    {
      title: "Actions",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() =>
              (window.location.href = `/requests/compassionate_access_requests/${record.id}`)
            }
          >
            View Details
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="py-8">
      
      <Table
        loading={tableLoading}
        rowKey="id"
        bordered
        columns={columns}
        dataSource={compassionateRequests}
      />
    </div>
  );
};

export default CompassionateRequests;
